import { Box, Typography } from "@mui/material";
function CountChips({
  label,
  value,
  color,
  onClick,
  selected,
  text,
}: {
  label: string;
  value: string | number;
  color: string;
  onClick?: () => void;
  selected?: boolean;
  text?: string;
}) {
  return (
    <Box
      sx={
        onClick
          ? {
              pointerEvents: "auto",
              boxShadow: selected ? 4 : "none",
              transform: selected ? "scale(1.01)" : "none",
              border: selected ? "2px dashed #519C66" : "1px dashed #ccc",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              "&:hover": selected
                ? {}
                : {
                    boxShadow: 4,
                    transform: "scale(1.01)",
                    border: "2px dashed #ccc",
                  },
              bgcolor: color,
              borderRadius: "4px",
              p: "5px 8px",
              textAlign: "center",
            }
          : {
              boxShadow: selected ? 4 : "none",
              transform: selected ? "scale(1.01)" : "none",
              border: selected ? "2px dashed #519C66" : "none",
              transition: "all 0.2s ease-in-out",
              bgcolor: color,
              borderRadius: "4px",
              p: "5px 8px",
              textAlign: "center",
              cursor: "default",
            }
      }
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation();
              onClick();
            }
          : undefined
      }
    >
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{
          color: text,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize:"14px"
        }}
      >
        {value}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        noWrap
        sx={{
          overflow: "hidden",
          color: text,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontWeight: 400,
          fontSize:"12px"
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default CountChips;
